import { Link } from "react-router-dom";

// Sober square-cornered link button matching the brand
export function BtnLink({ to, href, children, variant = "solid", className = "", ...props }) {
  const base =
    "inline-flex items-center justify-center px-8 py-4 overline transition-colors duration-300 select-none";
  const styles =
    variant === "solid"
      ? "bg-ink text-ivory hover:bg-gold hover:text-ink"
      : variant === "ghost"
      ? "text-ink hover:text-gold"
      : variant === "outline-light"
      ? "border border-ivory/40 text-ivory hover:bg-ivory hover:text-ink"
      : "border border-ink text-ink hover:bg-ink hover:text-ivory";
  const cls = `${base} ${styles} ${className}`;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <Link to={to} className={cls} {...props}>{children}</Link>;
}
